import React from 'react'
import "./HeaderItemsScheduleNotification.css"
import { useTranslation } from 'react-i18next'

const HeaderItemsScheduleNotification = () => {
    const { t } = useTranslation()
    return (
        <div className="width-100 header-item-schedule-notif flex mt-10 fw-700">
            <div className="column-schedule-notif column-1-schedule-notif">
                <p className="fs-14">{"ID"}</p>
            </div>
            <div className="column-schedule-notif column-2-schedule-notif">
                <p className="fs-14">{t("Notifications:schedule:index:label_24")}</p>
            </div>
            <div className="column-schedule-notif column-3-schedule-notif">
                <p className="fs-14">{t("Notifications:schedule:index:label_01")}</p>
            </div>
            <div className="column-schedule-notif column-4-schedule-notif">
                <p className="fs-14">{t("Notifications:schedule:index:label_09")}</p>
            </div>

            <div className="column-schedule-notif column-5-schedule-notif">
                <p className="fs-14">{t("Notifications:schedule:index:label_25")}</p>
            </div>

            <div className="column-schedule-notif column-6-schedule-notif">
                <p className="fs-14">{t("Notifications:schedule:index:label_08")}</p>
            </div>

            <div className="column-schedule-notif column-7-schedule-notif">
                <p className="fs-14">{t("Notifications:schedule:index:label_07")}</p>
            </div>
        </div>
    )
}

export default React.memo( HeaderItemsScheduleNotification )